/* eslint-disable @typescript-eslint/no-use-before-define */

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Unstable_Grid2";
import { IconButton, Stack, useMediaQuery, useTheme } from "@mui/material";
import { ExpandMore, ChevronRight, Close } from "@mui/icons-material";
import React from "react";
import { TreeItem, TreeView } from "@mui/x-tree-view";

export interface TreeViewCustomProps {
  title: string;
  isOpen: boolean;
  close: () => void;
  setSelected?: (id: string) => void;
  treeData: any[];
}

const TreeViewCustom = (props: TreeViewCustomProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [expanded, setExpanded] = React.useState<string[]>([]);
  const [selected, setSelected] = React.useState<string>("");
  const [itens, setItens] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (props.treeData) setItens(props.treeData);
  }, [props.treeData]);

  const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event: React.SyntheticEvent, nodeId: string) => {
    setSelected(nodeId);
    const selectedNode = findNodeById(nodeId, itens);
    if (
      props.setSelected &&
      selectedNode &&
      selectedNode.children.length === 0
    ) {
      props.setSelected(nodeId);
      setSelected("");
      setExpanded([]);
      props.close();
    }
  };

  const findNodeById = (id: string, nodes: any[]): any | undefined => {
    for (const node of nodes) {
      if (node.id.toString() === id) {
        return node;
      }
      const foundInChildren = findNodeById(id, node.children);
      if (foundInChildren) {
        return foundInChildren;
      }
    }
    return undefined;
  };

  const renderTree = (nodes: any) => (
    <TreeItem key={nodes.id} nodeId={`${nodes.id}`} label={nodes.name}>
      {Array.isArray(nodes.children)
        ? nodes.children.map((node: any) => renderTree(node))
        : null}
    </TreeItem>
  );

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={props.isOpen}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {props.title}
          <IconButton onClick={props.close} color="error">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Grid container xs={12} sm={12} md={12} lg={12}>
          <TreeView
            aria-label="controlled"
            defaultCollapseIcon={<ExpandMore />}
            defaultExpandIcon={<ChevronRight />}
            expanded={expanded}
            selected={selected}
            onNodeToggle={handleToggle}
            onNodeSelect={handleSelect}
            sx={{
              minHeight: 240,
              flexGrow: 1,
              width: `calc(100vw - ${theme.spacing(4)})`,
              overflowY: "auto",
            }}
          >
            {itens && itens.map((item) => renderTree(item))}
          </TreeView>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default TreeViewCustom;
